"use strict";
/** *******************************************************************************************************************
  Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
  
  Licensed under the Apache License, Version 2.0 (the "License").
  You may not use this file except in compliance with the License.
  You may obtain a copy of the License at
  
      http://www.apache.org/licenses/LICENSE-2.0
  
  Unless required by applicable law or agreed to in writing, software
  distributed under the License is distributed on an "AS IS" BASIS,
  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
  See the License for the specific language governing permissions and
  limitations under the License.                                                                              *
 ******************************************************************************************************************** */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const Typography_1 = __importDefault(require("@material-ui/core/Typography"));
const Checkbox_1 = __importDefault(require("@material-ui/core/Checkbox"));
const FormControlLabel_1 = __importDefault(require("@material-ui/core/FormControlLabel"));
const styles_1 = require("@material-ui/core/styles");
const clsx_1 = __importDefault(require("clsx"));
const useStyles = styles_1.makeStyles((theme) => ({
    checkbox: {
        marginRight: theme.spacing(0.4),
        '&:hover': {
            backgroundColor: 'transparent',
        },
        '&.Mui-checked': {
            color: theme.palette.info.dark,
        },
        '& .MuiSvgIcon-root': {
            height: '16px',
            width: '16px',
        },
    },
    checkboxWithDesc: {
        alignSelf: 'flex-start',
    },
    checkboxLabel: {
        marginLeft: 0,
    },
    checkboxLabelWitDesc: {
        '& > .MuiFormControlLabel-label': {
            marginTop: '-2px',
        },
    },
}));
/**
 * A Checkboxes allow the user to select one or more items from a set.
 */
const Checkbox = (_a) => {
    var { children, checked, disabled, description, indeterminate = false, onChange, controlId, ariaDescribedby, ariaLabel, ariaLabelledby, name, value } = _a, props = __rest(_a, ["children", "checked", "disabled", "description", "indeterminate", "onChange", "controlId", "ariaDescribedby", "ariaLabel", "ariaLabelledby", "name", "value"]);
    const classes = useStyles();
    const label = react_1.useMemo(() => (react_1.default.createElement(react_1.default.Fragment, null,
        children,
        description && (react_1.default.createElement(Typography_1.default, { variant: "subtitle1", component: "div" }, description)))), [children, description]);
    const muiCheckBox = (react_1.default.createElement(Checkbox_1.default, { disableRipple: true, className: clsx_1.default(classes.checkbox, { [classes.checkboxWithDesc]: description }), id: controlId, checked: checked, disabled: disabled, indeterminate: indeterminate, onChange: onChange, value: value, inputProps: {
            'aria-describedby': ariaDescribedby,
            'aria-label': ariaLabel,
            'aria-labelledby': ariaLabelledby,
            name,
        }, "data-testid": props['data-testid'] }));
    return (react_1.default.createElement(FormControlLabel_1.default, { control: muiCheckBox, label: label, className: clsx_1.default(classes.checkboxLabel, { [classes.checkboxLabelWitDesc]: description }) }));
};
exports.default = Checkbox;
//# sourceMappingURL=index.js.map